import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "GroupsReadUnreadDiagnostics" */ './lazyIndex');
});
export var lazyAddMarkAsReadDiagnostics = new LazyImport(lazyModule, function (m) { return m.addMarkAsReadDiagnostics; });
export var lazyAddUnreadCountNotificationDiagnostics = new LazyImport(lazyModule, function (m) { return m.addUnreadCountNotificationDiagnostics; });
export var lazyAddUnreadCountSubscriptionDiagnostics = new LazyImport(lazyModule, function (m) { return m.addUnreadCountSubscriptionDiagnostics; });
//# sourceMappingURL=index.js.map